module.exports = __webpack_public_path__ + "img/doppus.538319dc.png";